import { Dispatch, SetStateAction } from "react";

import { useLocalStorage } from "../../hooks";

/** Unlike the URL-synced table state, these are
 * device-local and never serialized to the URL. */
export interface TstTableLocalState {
    filtersCollapsed?: boolean;
}

/**
 * @param tableId - Unique key for the table (typically the table id).
 */
export function useTstTableLocalState(
    tableId: string
): [TstTableLocalState, Dispatch<SetStateAction<TstTableLocalState>>] {
    const [state, setState] = useLocalStorage<TstTableLocalState>(
        `tst-state-local:${tableId}`,
        {}
    );
    return [state, setState];
}
